import { useState, useCallback } from "react";

const STORAGE_KEY = "show-dropped-diagnosis-codes";

function loadPreference(): boolean {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) return JSON.parse(stored) === true;
  } catch {
    console.warn("Failed to load dropped codes preference from localStorage");
  }
  return false;
}

export function useDroppedCodesToggle() {
  const [showDropped, setShowDroppedState] = useState(loadPreference);

  const setShowDropped = useCallback((value: boolean) => {
    setShowDroppedState(value);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
      console.warn("Failed to save dropped codes preference to localStorage");
    }
  }, []);

  const toggleDropped = useCallback(() => {
    setShowDropped(!showDropped);
  }, [showDropped, setShowDropped]);

  return { showDropped, toggleDropped };
}
